import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Gamepad2 } from 'lucide-react';
import { motion } from 'framer-motion';

const DesktopLayout = ({ children, taskbarContent, sidebarIcons }) => {
    const { isAlterEgo, toggleAlterEgo } = useTheme();

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className={`min-h-screen w-full overflow-hidden relative flex flex-col ${isAlterEgo ? 'bg-black' : 'bg-mac-bg'}`}
        >
            {/* Background - Mesh Gradient or Dark Mode */}
            <div
                className={`absolute inset-0 z-0 transition-opacity duration-700 ${isAlterEgo ? 'opacity-0' : 'opacity-100'}`}
                style={{
                    background: 'linear-gradient(to bottom, #e0f2fe 0%, #f1f5f9 100%)',
                }}
            >
            </div>

            {isAlterEgo && (
                <div className="absolute inset-0 z-0 bg-neutral-950">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(120,0,255,0.1),transparent_50%)]"></div>
                </div>
            )}

            {/* Desktop Area */}
            <main className="flex-1 relative z-10 w-full h-full p-2 md:p-6 grid grid-flow-col grid-rows-[repeat(auto-fill,100px)] gap-4 content-start items-start justify-start">

                {/* Desktop Icons (hidden on mobile) */}
                <div className="hidden md:flex absolute top-6 left-6 flex-col gap-6 z-0">
                    {sidebarIcons}
                </div>

                {/* Windows Layer */}
                <div className="absolute inset-0 pointer-events-none z-10">
                    <div className="w-full h-full relative pointer-events-none">
                        {children}
                    </div>
                </div>
            </main>



            {/* Floating Alter Ego Button */}
            <button
                onClick={toggleAlterEgo}
                className="group fixed bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 z-50 px-4 py-2 md:px-6 md:py-3 bg-black rounded-full font-mono text-white uppercase tracking-[0.15em] md:tracking-[0.2em] shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center gap-2 md:gap-3 border border-white/10"
            >
                <Gamepad2 className="w-4 h-4 md:w-5 md:h-5 text-red-500" />
                <span className="text-xs md:text-sm font-bold">Switch to Alter Ego</span>
            </button>
        </motion.div>
    );
};

export default DesktopLayout;
